/**
 * @enum {Number}
 */
export const OTAUpgradeType = {
  /**
   * 单点GATT升级
   */
  GATT: 1,
  /**
   * Mesh升级
   */
  Mesh: 1 << 1,  //这种方式原生不关心
  /**
   * AP升级
   */
  AP: 1 << 2,
  /**
   * Obus升级
   */
  Obus: 1 << 3,  //这种方式原生不关心

  /**
   * 低功耗 GATT
   */
  LEGATT: 1 << 4, // 低功耗 GATT

  /**
   * BLE 转 DALI
   */
  BLE_DALI: 1 << 5, // BLE 转 DALI 导轨控制器下的导轨灯升级

  SIGMESH_OTA: 1 << 6,

  /**
 * BLE 转 DALI
 */
  BLE_DALI_2: 1 << 7, // BLE 转 DALI 
  /**
   * 云端发送通知给设备升级，支持批量升级(通知设备直升)
   */
  IOT_NOTIFICATION: 1 << 8,
  
   /**
   * 中控屏ota升级
   */
  DEVICE_LOCAL : 1 << 10
}